import React, { useContext } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import AppContext from '../../../contexts/App';

const Recaptcha = React.forwardRef((props, ref) => {
    const { state } = useContext(AppContext);

    const onError = e => console.log('reCaptcha error encounterd', e);

    return <ReCAPTCHA badge='inline' onError={onError} ref={ref} sitekey={state.settings?.googleSettings?.reCaptchaSiteKeyV3} size='invisible' style={{ display: 'none' }} />;
});

export default Recaptcha;
